"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentedMessage = void 0;
var SegmentedMessage_1 = require("./libs/SegmentedMessage");
Object.defineProperty(exports, "SegmentedMessage", { enumerable: true, get: function () { return SegmentedMessage_1.SegmentedMessage; } });
//# sourceMappingURL=index.js.map